import * as Sentry from '@sentry/react'
import type { InternalAxiosRequestConfig } from 'axios'

import { fetchAccessToken } from '@/libs/auth/fetch-access-token'
import { selectedDcIdAtom } from '@/routes/_protected/$tenantKey/-states/atoms/selected-dc-id-atom'
import { tenantStore } from '@/routes/_protected/$tenantKey/-states/tenant-store'

// 拠点(dcId)コンテキストに紐づかない API の先頭パスセグメント。
// BE 側 auth.interceptor と同一基準 (users=ログインユーザー自身, auth=認証)。
// これらは拠点確定前の bootstrap (例: /api/users/me) に必要なため X-DC-Id を要求しない。
const DC_CONTEXT_EXEMPT_SEGMENTS = ['auth', 'users']

const requiresDcContext = (url: string): boolean => {
  const [firstSegment] = url.replace(/^\/?api\//, '').split('/')
  return !DC_CONTEXT_EXEMPT_SEGMENTS.includes(firstSegment)
}

export const authenticationRequestInterceptor = async (
  request: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const accessToken = await fetchAccessToken?.()

  if (accessToken) {
    request.headers.set('Authorization', `bearer ${accessToken}`)

    if (requiresDcContext(request.url ?? '')) {
      const selectedDcId = tenantStore.get(selectedDcIdAtom)
      if (selectedDcId === 0) {
        // テナント内 API へ拠点未選択でアクセスするのは想定外。
        // request interceptor の throw は response chain をスキップするため
        // Sentry.captureException で明示的に記録してから throw する。
        const error = new Error(
          '[auth interceptor] selectedDcId is not set for authenticated user'
        )
        Sentry.captureException(error)
        throw error
      }
      request.headers.set('X-DC-Id', String(selectedDcId))
    }
  }

  return Promise.resolve(request)
}
